import { ComponentStyleConfig, extendTheme } from "@chakra-ui/react";
import { ButtonTheme } from "./componentThemes/ButtonTheme";
import { inputTheme } from "./componentThemes/InputTheme";
import { menuTheme } from "./componentThemes/menuTheme";

import { mode } from "@chakra-ui/theme-tools";

const styles = {
  global: (props: any) => ({
    body: {
      color: mode("#18191B", "white")(props),
      bg: mode("white", "#2F3438")(props),
    },
    ".chakra-menu__menu-list": {
      bg: mode("black", "white")(props),
      borderColor: mode("white", "#2F3438")(props),
    },
  }),
};

const theme: ComponentStyleConfig = extendTheme({
  styles,
  fonts: {
    certificate:
      "'BareunBatangPro2', 'BareunBatangPro3', 'Poppins', sans-serif",
    certificateBold:
      "'BareunBatangPro3', 'BareunBatangPro2', 'Poppins', sans-serif",
  },
  components: {
    Button: ButtonTheme,
    Input: inputTheme,
    Menu: menuTheme,
  },

  colors: {
    primary: {
      100: "#B6E9E7",
      200: "#1782FF",
      300: "#030914",
      400: "#8A3FFC",
      500: "#FFFFFF",
      600: "#000000",
      800: "#3075B6",
      link: "#1782FF",
      grayText: "#5C6670",
      shineGrayText: "#5C6670",
      700: "rgba(23, 130, 255, 0.2)",
    },
    purple: {
      100: "F7F5FF",
      200: "#F0EDFF",
      300: "#8B76FF",
      500: "#337CC1",
      600: "#E7E2FF",
      700: "#290C81",
      purpleGradient: "linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)",
    },
    green: {
      100: "#006762",
    },
    gray: {
      100: "#E4EBF0",
      200: "#E4EBF0",
      300: "#A7B2BA",
      400: "#E4EBF0",
      500: "#5C6670",
      600: "#E4EBF0",
      700: "#2F3438",
      800: "#gba(24, 25, 27, 1)",
      contactContainer: "#FFFFFF",
      input: "#FFFFFF",
      border: "#E4EBF0",
      icon: "#676879",
    },
    black: {
      100: "#18191B",
      101: "#000000",
      200: "#323338",
      400: "#F1F6F9",
      500: "#2023261A",
    },
    white: {
      100: "#FFFFFF",
    },
    danger: {
      100: "#FFEEF1",
      200: "#EC5444",
      900: "#EE3D5D",
    },
    success: {
      100: "#54CBC7",
    },
    menu: {
      100: "#0000FF",
      200: "#EBECEF",
      300: "#EBECEF",
    },
    inverse: {
      black: "#18191B",
      gray: "#FFFFFF",
    },
    border: {
      inverseGray: "#F1F6F9",
      100: "#255B8D",
      200: "#E6E9EF",
    },
    theme: {
      yallow: {
        50: "#FFFAEC",
        100: "#F6C23A",
      },
      text: {
        primaryDark: "#18191B",
      },
      button: {
        primary: "#337CC1",
      },
      white: "#FFFFFF",
      brown: {
        100: "rgba(141, 145, 158, 0.1)",
      },
      primary: {
        50: "#2B3F56",
        100: "#E8EEFD",
      },
      gray: {
        25: "#E6E9EF",
        50: "rgba(141, 145, 158, 0.15)",
        100: "#E4EBF0",
        200: "#CDD6DC",
        300: "#A7B2BA",
        400: "#798692",
        500: "#5C6670",
        600: "#40464B",
        700: "#2F3438",
        lightGray: "#4C4862",
        lightGray700: "#FFFFFF",
        lightGray500: "#5C6670",
        lightGray500to200: "#5C6670",
        lightGray200: "#C5C7D0",
        zeroGray: "#F1F6F9",
        gray500to300: "#5C6670",
        gray400to200: "#798692",
        neutral: "#0D0D0D",
      },
      danger: {
        100: "#FFEEF1",
        200: "#EC5444",
        900: "#EE3D5D",
      },
      alert: {
        100: "rgba(80, 183, 240, 0.2)",
        200: "rgba(23, 130, 255, 0.2)",
        900: "#50B7F0",
      },
      bg: {
        container: "#F6F8FC",
        yallow: "#F6C23A",
        box: "#FFF",
        doc: "#F1F6F9",
        couponBox: "#E8EEFD",
        purple: "#F7F5FF",
      },
      shadow: {
        gray: {
          100: "rgba(32, 35, 38, 0.1)",
        },
      },
      success: {
        50: "rgba(64, 220, 145, 0.2)",
        100: "#32D687",
      },
    },
  },
  breakpoints: {
    sm: "600px",
    md: "900px",
    lg: "1250px",
    halfxl: "1450px",
    xl: "1600px",
    "2xl": "1920px",
  },
});

export default theme;
